import React, { useCallback, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";

import KuellyLogo from "./assets/img/kuelly-logo.png";

import KuellyHeroHeader from "./components/header";
import IntroSection from "./components/IntroSection";
import ObjetivoSection from "./components/Objetivo";
import TeAyudamosSection from "./components/Ayuda";
import NuestraEspecialidadSection from "./components/Especialidad";
import Footer from "./components/Footer";

const App = () => {
  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    el.scrollIntoView({
      behavior: prefersReduced ? "auto" : "smooth",
      block: "center",
      inline: "nearest",
    });
  }, []);

  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      setTimeout(() => scrollToId(id), 0);
    }
  }, [scrollToId]);

  const closeNavbarOnMobile = () => {
    const navbar = document.getElementById("navbarNav");
    if (!navbar) return;
    if (navbar.classList.contains("show")) {
      const collapse =
        window.bootstrap?.Collapse.getInstance(navbar) ||
        new window.bootstrap.Collapse(navbar, { toggle: false });
      collapse.hide();
    }
  };

  const handleNavClick = (e, targetId) => {
    e.preventDefault();
    scrollToId(targetId);
    closeNavbarOnMobile();
  };

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary-custom sticky-top">
        <div className="container-fluid">
          <a
            className="navbar-brand"
            href="#inicio"
            aria-label="Ir a inicio"
            onClick={(e) => handleNavClick(e, "inicio")}
          >
            <img src={KuellyLogo} alt="Kuelly" className="navbar-logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Abrir menú"
          >
            <span className="navbar-toggler-icon" />
          </button>

          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarNav"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#inicio"
                  onClick={(e) => handleNavClick(e, "inicio")}
                >
                  Inicio
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#introduccion"
                  onClick={(e) => handleNavClick(e, "introduccion")}
                >
                  Nosotros
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#objetivo"
                  onClick={(e) => handleNavClick(e, "objetivo")}
                >
                  Objetivo
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#servicios"
                  onClick={(e) => handleNavClick(e, "servicios")}
                >
                  Servicios
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#especialidad"
                  onClick={(e) => handleNavClick(e, "especialidad")}
                >
                  Especialidad
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#ubicacion"
                  onClick={(e) => handleNavClick(e, "ubicacion")}
                >
                  Ubicación
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link"
                  href="#contacto"
                  onClick={(e) => handleNavClick(e, "contacto")}
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Secciones */}
      <main>
        <section id="inicio" className="section-anchor">
          <KuellyHeroHeader />
        </section>

        <section id="introduccion" className="section-anchor">
          <IntroSection />
        </section>

        <section id="objetivo" className="section-anchor">
          <ObjetivoSection />
        </section>

        <section id="servicios" className="section-anchor">
          <TeAyudamosSection />
        </section>

        <section id="especialidad" className="section-anchor">
          <NuestraEspecialidadSection />
        </section>

        <section id="ubicacion" className="section-anchor">
          <div
            className="map-container"
            style={{ width: "100%", height: "92vh" }}
          >
            <iframe
              title="Ubicación - Real de Juriquilla Prados"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3731.3730946737646!2d-100.4691817175564!3d20.73566670810526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d357a337274149%3A0x8e8e797a0dd534cc!2sReal%20de%20Juriquilla%20Prados!5e0!3m2!1ses!2smx!4v1755291234854!5m2!1ses!2smx"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default App;
